export default __webpack_public_path__ + "static/media/Sansita-BoldItalic.58674750.ttf";